module.exports = __webpack_public_path__ + "assets/a47580de4ef187d84d5231dc353c8d06.mp3";